function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11.25",
  fill: "#9251AC"
}), React.createElement("path", {
  fill: "#F6A4EB",
  d: "M20.5 3.53a12 12 0 10-17 16.94 12 12 0 0017-16.94zM19.1 19.1c-.12.1-.25.2-.39.29l.3.76c-1.84 1.49-3.86 1.88-6.63 1.88-5.38 0-8.88-3.61-8.88-9 0-4.84 2.72-8 7.26-8 3 0 5.1 1.24 5.5 2.75L19.06 5a1 1 0 011.44.04c1.74 2.08 2.31 4.32 2.31 7 .01 2.2-1.31 5.16-3.72 7.08l.01-.01z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M13.45 21.07c-4.88 0-7.28-3.69-7.28-6.6 0-2.92 1.8-4.46 3.5-4.46.71-.02 1.4.3 1.82.88A1 1 0 0013 11l3.25-3.25c-.38-1.5-2.46-3.44-5.5-3.44-4.53.01-8.12 3.83-8.12 8.69a9.58 9.58 0 009.75 9.55 11 11 0 006.97-2.4.5.5 0 00-.6-.8 8.89 8.89 0 01-5.3 1.72z"
}))));